<template>
    <svg
        :class="{
            'icon__twitter': hoverState == true
        }"
        width="22"
        height="17"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="twitterIconTitle"
    >
        <title id="twitterIconTitle">Twitter logo</title>
        <path
            d="M6.916 17c3.412.022 6.692-1.253 9.104-3.542 2.411-2.29 3.755-5.4 3.728-8.636v-.55A8.913 8.913 0 0 0 22 2.06a9.432 9.432 0 0 1-2.591.67A4.335 4.335 0 0 0 21.383.364a9.448 9.448 0 0 1-2.868 1.042C17.267.088 15.285-.355 13.546.297c-1.738.652-2.864 2.262-2.823 4.034a3.94 3.94 0 0 0 .116.974C7.206 5.137 3.82 3.51 1.528.831a4.155 4.155 0 0 0-.634 2.152c-.008 1.433.749 2.772 2.01 3.56a4.584 4.584 0 0 1-2.01-.56v.085C.876 8.12 2.393 9.896 4.513 10.305c-.388.098-.788.15-1.189.153-.3 0-.6-.028-.893-.085.589 1.746 2.285 2.942 4.217 2.974a9.367 9.367 0 0 1-5.576 1.788A9.097 9.097 0 0 1 0 15.076 13.3 13.3 0 0 0 6.916 17"
            fill="#F2F2F2"
            fill-rule="evenodd"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconTwitter',
    props: {
        hoverState: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__twitter {
    path {
        transition: all 0.3s ease;
    }
    &:hover {
        path {
            fill: $primary;
        }
    }
}
</style>
